//constants
import {EVENT_ID, defaultPage} from '../constants';
//types
import {IRequestWithPagination} from '../types';

export const camelize = (str: string): string => {
	return str
		.replace(/(?:^\w|[A-Z]|\b\w)/g, (word) => {
			return word.toUpperCase();
		})
		.replace(/\s+/g, '');
};

export const getDefaultRequestBody = <T extends string>(id: number, targetNameId: T) =>
	({
		[targetNameId]: id,
		page: defaultPage,
		searchName: '',
		sortColumn: '',
		isOrderDesc: false,
	} as Record<T, number> & Omit<IRequestWithPagination, typeof EVENT_ID>);

export const isValidPositiveAmount = (value: string) => {
	const regex = /^(?!0\d)\d*([.,]\d{0,2})?$/;
	return regex.test(value);
};
